import * as React from 'react'
import { I18nService } from '../../../services/utils/i18n.service'
import { CustomerPlanBase } from '../../../services/json-schemas/base/customer_plan'
import ProgressBarComponent from '../../shared/progress-bar.component'

interface Props {
  customerPlan: Pick<CustomerPlanBase, 'quantity' | 'quantity_frequency'>
  startDate: moment.Moment
  quantityLeft: number
}

const i18nScoped = new I18nService(require('./customer-plan-subscription-quantity-left-in-period-progress-bar.component.yml'))

export function CustomerPlanSubscriptionQuantityLeftInPeriodProgressBarComponent ({ customerPlan, startDate, quantityLeft }: Props) {
  const endDate = customerPlan.quantity_frequency === 'weekly'
    ? startDate.clone().add(6, 'days')
    : startDate.clone().add(1, 'month').subtract(1, 'day')

  return <>
    <ProgressBarComponent max={ customerPlan.quantity } value={ customerPlan.quantity - quantityLeft } />

    <span className="txtSmall">{ i18nScoped.t(customerPlan.quantity_frequency + '_period', { from: startDate.format('L'), to: endDate.format('L') }) }</span>
    <span className="u-mlxs u-mrxs">•</span>
    <span className="txtSmall">{ i18nScoped.t('quantity_left', { count: quantityLeft }) }</span>
  </>
}
